// src/hooks/useIntersectionObserver.js
import { useEffect, useRef, useState } from 'react'

export function useIntersectionObserver(options = {}) {
    const [isIntersecting, setIsIntersecting] = useState(false)
    const ref = useRef(null)

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsIntersecting(entry.isIntersecting)
        }, options)

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current)
            }
        }
    }, [options])

    return [ref, isIntersecting]
}

export function useLazyLoad(options = {}) {
    const [ref, isIntersecting] = useIntersectionObserver(options)
    const [hasLoaded, setHasLoaded] = useState(false)

    useEffect(() => {
        if (isIntersecting && !hasLoaded) {
            setHasLoaded(true)
        }
    }, [isIntersecting, hasLoaded])

    return [ref, hasLoaded]
}